import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { format, parse } from 'date-fns';

import boTheme from '@ecp/common/src/style/theme/bo';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { VerticalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

const ContentsAudit = ({ createDate, creatorName, updateDate, updaterName }) => {
  const getFormattedDate = useCallback((date) => {
    return format(parse(date, 'yyyyMMddHHmmss', new Date()), 'yyyy-MM-dd HH:mm');
  }, []);

  return (
    <>
      {createDate && (
        <>
          <AuditLabel>등록일시</AuditLabel>
          <Spacing right={4} />
          <AuditValue>{getFormattedDate(createDate)}</AuditValue>
          <Spacing right={8} />
        </>
      )}
      {creatorName && (
        <>
          <AuditLabel>등록자</AuditLabel>
          <Spacing right={4} />
          <AuditValue>{creatorName}</AuditValue>
          <Spacing right={8} />
        </>
      )}
      <VerticalDivider color={boTheme.color.sub7} height={'8px'} />
      {updateDate && (
        <>
          <Spacing right={8} />
          <AuditLabel>최종수정일시</AuditLabel>
          <Spacing right={4} />
          <AuditValue>{getFormattedDate(updateDate)}</AuditValue>
        </>
      )}
      {updaterName && (
        <>
          <Spacing right={8} />
          <AuditLabel>최종수정자</AuditLabel>
          <Spacing right={4} />
          <AuditValue>{updaterName}</AuditValue>
        </>
      )}
    </>
  );
};

ContentsAudit.propTypes = {
  createDate: PropTypes.string,
  creatorName: PropTypes.string,
  updateDate: PropTypes.string,
  updaterName: PropTypes.string,
};

const AuditLabel = styled(TextBox)`
  font-size: ${boTheme.font.size.error};
  font-weight: ${boTheme.font.weight.bold};
  color: ${boTheme.color.sub1};
`;

const AuditValue = styled(TextBox)`
  font-size: ${boTheme.font.size.error};
  font-weight: ${boTheme.font.weight.regular};
  color: ${boTheme.color.sub2};
`;

export default ContentsAudit;
